import React from 'react';
import { ArrowLeftIcon, SaveIcon, UndoIcon, RedoIcon, DownloadIcon, HelpCircleIcon } from 'lucide-react';
import { useTheme } from './ThemeProvider';
interface AppHeaderProps {
  currentScreen: string;
  onBack?: () => void;
}
export function AppHeader({
  currentScreen,
  onBack
}: AppHeaderProps) {
  const {
    theme
  } = useTheme();
  return <header className="bg-white border-b border-gray-200 shadow-sm z-10 dark:bg-darkbg-secondary dark:border-darkbg-border" data-id="element-6">
      <div className="flex items-center justify-between h-16 px-4" data-id="element-7">
        <div className="flex items-center" data-id="element-8">
          {onBack && <button onClick={onBack} className="p-2 rounded-md text-gray-500 hover:text-blue-600 hover:bg-gray-100 focus:outline-none dark:text-gray-300 dark:hover:text-accent-blue dark:hover:bg-darkbg-primary" data-id="element-9">
              <ArrowLeftIcon className="h-6 w-6" data-id="element-10" />
            </button>}
          <div className="ml-4" data-id="element-11">
            <span className="text-2xl font-bold text-blue-600 dark:text-accent-blue" data-id="element-12">
              CADVIX
            </span>
          </div>
          <div className="flex items-center space-x-4 ml-4" data-id="element-13">
            <span className="text-lg font-medium text-gray-700 dark:text-gray-200" data-id="element-14">
              {currentScreen === 'room' ? 'Room Builder' : ''}
            </span>
          </div>
        </div>
        <div className="flex items-center space-x-2" data-id="element-15">
          <button className="p-2 rounded-md text-gray-500 hover:text-blue-600 hover:bg-gray-100 focus:outline-none dark:text-gray-300 dark:hover:text-accent-blue dark:hover:bg-darkbg-primary" data-id="element-16">
            <UndoIcon className="h-5 w-5" data-id="element-17" />
          </button>
          <button className="p-2 rounded-md text-gray-500 hover:text-blue-600 hover:bg-gray-100 focus:outline-none dark:text-gray-300 dark:hover:text-accent-blue dark:hover:bg-darkbg-primary" data-id="element-18">
            <RedoIcon className="h-5 w-5" data-id="element-19" />
          </button>
          
          <button className="p-2 rounded-md text-gray-500 hover:text-blue-600 hover:bg-gray-100 focus:outline-none dark:text-gray-300 dark:hover:text-accent-blue dark:hover:bg-darkbg-primary" data-id="element-20">
            <DownloadIcon className="h-5 w-5" data-id="element-21" />
          </button>
          <button className="p-2 rounded-md text-gray-500 hover:text-blue-600 hover:bg-gray-100 focus:outline-none dark:text-gray-300 dark:hover:text-accent-blue dark:hover:bg-darkbg-primary" data-id="element-22">
            <HelpCircleIcon className="h-5 w-5" data-id="element-23" />
          </button>
          {currentScreen === 'room' ? <button className="ml-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm font-medium dark:bg-accent-blue dark:hover:bg-blue-500" data-id="element-24">
              Save and Start Design
            </button> : <button className="ml-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm font-medium dark:bg-accent-blue dark:hover:bg-blue-500" data-id="element-25">
              Save Design
            </button>}
        </div>
      </div>
    </header>;
}